export enum AddressTypes {
    Main = 'MAIN',
    SecondaryOne = 'SECONDARY_ONE',
    SecondaryTwo = 'SECONDARY_TWO',
}
